import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import * as ETVConstants from '../ETVConstants';

class ConfirmDialog extends React.Component {
  render() {
    const { open, onClose, onAgree, text, text_line_2 } = this.props;

    return (
      <Dialog
        open={open}
        onClose={() => {}}
        maxWidth="xs"
        fullWidth
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 2,
            boxShadow: 10,
          },
        }}
      >
        <DialogTitle id="confirm-dialog-title">
          <Box display="flex" alignItems="center">
            <InfoIcon fontSize="large" sx={{ color: '#1976d2', mr: 1 }} />
            <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
              {ETVConstants.trans("confirm")}
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography variant="body1" color="text.primary">
            {text}
          </Typography>
          {text_line_2 && (
            <Typography variant="body2" color="text.secondary" mt={1}>
              {text_line_2}
            </Typography>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={onClose} color="inherit">
            {ETVConstants.trans("cancel")}
          </Button>
          <Button onClick={onAgree} color="primary" variant="contained" autoFocus>
            {ETVConstants.trans("agree")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ConfirmDialog;
